import { useState } from 'react'
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo';
import GeneralDetailsTab1 from './GeneralDetailsTab1';
import Table from './Table';
import Table2 from './Table2';
import TotalBox from './TotalBox';
import AdditionalDiscount from './AdditionalDiscount';
import Tab2Box from './Tab2Box';
import EditItemModal from './EditItemModal';

function GRNForm() {
  // Item Table State
  const createNewItemRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: 1,
    uom: "",
    rate: "0",
    amount: "0",
  });
  const ItemColumns = [
  { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
  { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
  { title: "Item Image", field: "item_image", width: "15%" },
  { title: "Item Code", field: "item_code", width: "15%" },
  { title: "Item Name", field: "item_name", width: "15%" },
  { title: "Quantity", field: "quantity", width: "7%" },
  { title: "Rate(INR)", field: "rate_inr", width: "10%" },
  { title: "Amount(INR)", field: "amount_inr", width: "10%" },
  { title: "Tag Price", field: "tag_price", width: "10%" },
  { title: "Discount", field: "discount", width: "10%" },
  { title: "Setting", field: "setting", width: "5%" },
 ];
  // Item Table State



  // Metal Table State
const MetalColumns = [
  { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
  { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
  { title: "Design Code", field: "design_code", width: "11%" },
  { title: "Vendor Design Code", field: "vendor_design_code", width: "11%" },
  { title: "Vendor Name", field: "vendor_name", width: "11%" },
  { title: "Metal", field: "metal", width: "10%" },
  { title: "Metal Rate", field: "metal_rate", width: "10%" },
  { title: "Metal Amount", field: "metal_amount", width: "10%" },
  { title: "Metal Color", field: "metal_color", width: "10%" },
  { title: "Gross Weight", field: "gross_weight", width: "10%" },
  { title: "Purity", field: "purity", width: "10%" },
  { title: "Metal Pure Gold", field: "metal_pure_gold", width: "10%" },
  { title: "Setting", field: "setting", width: "5%" },
];
  // Metal Table State


  // Diamond Table State
  const DiamondColumns = [
  { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
  { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
  { title: "Design Code", field: "design_code", width: "11%" },
  { title: "Diamond Name", field: "diamond_name", width: "11%" },
  { title: "Vendor Design Code", field: "vendor_design_code", width: "11%" },
  { title: "Vendor Name", field: "vendor_name", width: "11%" },
  { title: "Diamond Rate", field: "diamond_rate", width: "10%" },
  { title: "Diamond Amount", field: "diamond_amount", width: "10%" },
  { title: "Diamond Size", field: "diamond_size", width: "10%" },
  { title: "Diamond Shape", field: "diamond_shape", width: "10%" },
  { title: "Gross Weight", field: "gross_weight", width: "10%" },
  { title: "Setting", field: "setting", width: "5%" },
   ];
  // Diamond Table State
  


  // Store Table State
  const StoreColumns = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Store Code", field: "store_code", width: "15%" },
    { title: "Store Name", field: "store_name", width: "15%" },
    { title: "Vendor Name", field: "vendor_name", width: "15%" },
    { title: "Quantity", field: "quantity", width: "10%" },
    { title: "Rate(INR)", field: "rate_inr", width: "10%" },
    { title: "Amount(INR)", field: "amount_inr", width: "10%" },
    { title: "Remarks", field: "remarks", width: "15%" },
    { title: "Setting", field: "setting", width: "5%" },
  ];
  // Store Table State
  
  
  // Labour Table State
  const LabourColumns = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Design Code", field: "design_code", width: "15%" },
    { title: "Vendor Name", field: "vendor_name", width: "15%" },
    { title: "Labour Type", field: "labour_type", width: "15%" },
    { title: "Labour Rate", field: "labour_rate", width: "10%" },
    { title: "Labour Amount", field: "labour_amount", width: "10%" },
    { title: "Gross Weight", field: "gross_weight", width: "10%" },
    { title: "Remarks", field: "remarks", width: "10%" },
    { title: "Setting", field: "setting", width: "5%" },
  ];
  // Labour Table State
  
  
  // Wastage Table State
  const WastageColumns = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Design Code", field: "design_code", width: "15%" },
    { title: "Vendor Name", field: "vendor_name", width: "15%" },
    { title: "Metal Type", field: "metal_type", width: "15%" },
    { title: "Wastage %", field: "wastage_percent", width: "10%" },
    { title: "Wastage Weight", field: "wastage_weight", width: "10%" },
    { title: "Wastage Amount", field: "wastage_amount", width: "10%" },
    { title: "Remarks", field: "remarks", width: "10%" },
    { title: "Setting", field: "setting", width: "5%" },
  ];
  // Wastage Table State


  



  const [activeTab, setActiveTab] = useState('tab1');
  const [showEditModal, setShowEditModal] = useState(false);
  const [tab1Data, setTab1Data] = useState({
    series: '',
    customer: '',
    date_of_visit: '',
    company: '',
    contact_no: '',
    customer_type: '',
    assigned_to: '',
    help_by:''
  });

  const additionalData = {
    tab1: {
      compnay: [{"name" :'Malabar gold and diamonds'}],
      customer_types: [{"name" :'Regular'},{"name" :'VIP'},{"name" :'Wholesale'}],
      assigned_to:[{"name" :'Akash'},{"name" :'Ajay'},{"name" :'Sooraj'}],
      helped_by: [{"name" :'Megha'},{"name" :'Sulekha'},{"name" :'Rahul'}],
    },
    // tab2: {
    //     industries: ['IT', 'Manufacturing', 'Healthcare'],
    //     businessSizes: ['Small', 'Medium', 'Large']
    // }
  };

  const tabs = [
    { id: 'tab1', label: 'General Details', component: GeneralDetailsTab1 },
    { id: 'tab2', label: 'Address & Contact', component: Tab2Box },
  ];

  const updateTab1 = (field, value) => {
    console.log(field, value, "check-one");

    setTab1Data(prev => ({ ...prev, [field]: value }));
  };

  // const updateTab2 = (field, value) => {
  //     setTab2Data(prev => ({ ...prev, [field]: value }));
  // };

  const resetTab1 = () => setTab1Data({
    customerName: '', email: '', phone: '', dateOfBirth: '', gender: '', occupation: ''
  });

  // const resetTab2 = () => setTab2Data({
  //     companyName: '', taxId: '', businessType: '', industry: '', employeeCount: '', annualRevenue: ''
  // });

  const resetAll = () => {
    resetTab1();
    // resetTab2();
  };

  const handleSubmit = () => {
    const allData = {
      basicInfo: tab1Data,
      // companyInfo: tab2Data
    };
    console.log('Submitting:', allData);
  };
const getCurrentTabInfo = () => {
  switch (activeTab) {
    case 'tab1':
      return {
        component: GeneralDetailsTab1,
        data: tab1Data,
        onChange: updateTab1,
        extraData: additionalData.tab1
      };
    
    case 'tab2':
        return {
            component: Tab2Box,
            data: tab1Data,
            onChange: updateTab1,
            extraData: additionalData.tab1
        };
    
    default:
      return null;
  }
};

  const currentTab = getCurrentTabInfo();
  const CurrentComponent = currentTab?.component;

  return (
    <FormLayoutTwo
      title="New GRN"
      breadcrumbs={[
        { label: "Inbound" },
        {
          label: "GRN List",
          url: "/inbound/grn/create-grn-receipt",
        },
      ]}
      status={'New'}
      actionButtons={
        <>

          <Button
            className="custom-btn-00989"
            iconName="LuFilePlus2"
            onClick={handleSubmit}
            iconSize={12}
          >
            Save
          </Button>

        

          <Button
            to="/brand/create-brand"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: '21px' }}
          />
        </>
      }
    >
      <div style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>


        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end">
            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              {tabs.map((tab) => (
                <li key={tab.id} className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a
                    className={`removeborder234 nav-link ${activeTab === tab.id
                      ? 'active-tab-custom-new text-white'
                      : 'tab-inactive-custom'
                      } border-radius-top-corner`}
                    onClick={() => setActiveTab(tab.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    {tab.label}
                    <GetIcon iconName={activeTab === tab.id ? "MdKeyboardArrowDown" : "MdKeyboardArrowRight"}   size={15}    />
                  </a>
                </li>
              ))}
            </ul>
            <div className="d-flex align-items-center mb-2 px-3">
              <GetIcon iconName="CgAttachment" size={12} />
              <span className="fw-semibold ms-1" style={{ color: "#4b002b",fontSize:'13px' }}>
                Attachments
              </span>
            </div>
          </div>
        </div>


        <div className=" " style={{background :''}}>
          <div className="row">
            <div className="col-12">
              <div >
                {CurrentComponent && currentTab && (
                  <CurrentComponent
                    formData={currentTab.data}
                    onFieldChange={currentTab.onChange}
                    extraData={currentTab.extraData}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {activeTab == "tab1" && <div className="px-3 mb-3" style={{background :''}}>
          <div className="row">
            <div className="col-12">
              <div >
                <Table
                title="Items"
                setselected_item_data={[]}
                createNewRow={createNewItemRow}
                columns={ItemColumns}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>
              <div >
                <Table
                title="Metal"
                setselected_item_data={[]}
                createNewRow={createNewItemRow}
                columns={MetalColumns}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>
              <div >
                <Table
                title="Diamond"
                setselected_item_data={[]}
                createNewRow={createNewItemRow}
                columns={DiamondColumns}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>
              <div >
                <Table
                title="Stone"
                setselected_item_data={[]}
                createNewRow={createNewItemRow}
                columns={StoreColumns}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>
              <div >
                <Table
                title="Labour"
                setselected_item_data={[]}
                createNewRow={createNewItemRow}
                columns={LabourColumns}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>
              <div >
                <Table
                title="Wastage"
                setselected_item_data={[]}
                createNewRow={createNewItemRow}
                columns={WastageColumns}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>

            </div>
          </div>
        </div>}



              {activeTab == "tab1" && <div className="px-3" style={{background :''}}>
          <div className="row">
            <div className="col-12">
              <div >
                <Table2
                setselected_item_data={[]}
                rows={[]}
                setRows={()=>{}}
                list_data={()=>{}}
                po_status={""}
                 />
              </div>
            </div>
          </div>
        </div>}




        
               {activeTab == "tab1" && <div className="px-3 my-3" style={{background :''}}>
          <div className="row">
            <div className="col-4">
              <TotalBox />
            </div>
            <div className="col-4">
              <AdditionalDiscount />
            </div>
            <div className="col-4">
             <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                              <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0 pb-2' style={{fontSize:'16px',fontWeight:'600'}}>Get Items From</p>
                                </div>
                              </div>
                              <div style={{ display: 'flex', gap: '15px' }}>
                                 <div style={{ flex: 1 }}>
                                    <p className='m-0 pobtn' style={{cursor:'pointer'}} onClick={()=>{setShowEditModal(!showEditModal)}}>Purchase Order</p>
                                </div>

                              </div>
             </div>
              <div>

              </div>
            </div>
          </div>
        </div>}



        <EditItemModal 
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
      />


      </div>
    </FormLayoutTwo>
  )
}

export default GRNForm